import {load} from '@shopify/theme-sections';
import ArticleVideos from '../snippets/article-videos';
import ArticleCollectionSlider from '../components/article-collection-slider';

document.addEventListener('DOMContentLoaded', () => {
  ArticleCollectionSlider().init();
  ArticleVideos().init();

  load('*');
});
